import { Outlet, useLocation } from 'react-router-dom'
import { Header, Segment } from 'semantic-ui-react'
import SecondaryMenu from '../../components/SecondaryMenu'
import Layout from '../Layout'
import './About.scss'

function About() {
  const location = useLocation()
  return (
    <Layout>
      <div className='about_header'>
        <Header as='h1'>About the project</Header>
        <Header as='h3' id='about_header_description'>More about ROSIE</Header>
      </div>
      <div className='about_body'>
        <div className='left_panel'>
          <SecondaryMenu
            items={[
              {
                name: 'Project description',
                link: 'description',
                icon: 'notePanel'
              },
              {
                name: 'Observatory',
                link: 'observatory',
                icon: 'circle'
              },
              {
                name: 'Receiver live view',
                link: 'live',
                icon: 'video'
              },
              {
                name: 'Interference map',
                link: 'interference',
                icon: 'barChart'
              }
            ]}
            activeItem={location.pathname.split('/')[2]}
          />
        </div>
        <Segment className='right_panel fade-in'>
          <Outlet />
        </Segment>
      </div>
    </Layout>
  )
}

About.propTypes = {
}

export default About
